import React, { useState } from 'react';
import LoaderImg from '../../../assets/svg/loader.svg';
import { default as t } from '../../../utils/i18n';
import './loader.scss';

const Loader = () => {

    return (
        <div className="loader-overlay">
            <div className="loader-content">
            <img src={LoaderImg} alt="Loader" className="loader" />
            <span className="loader-title">
                {t('loader.label')}...
  </span>
            </div>
            
        </div>
    );
}

export default Loader;


